import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IRecordsMeta{
  idBank: FormInputMeta;
  nameBank: FormInputMeta;
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  PAN: FormInputMeta,

  
  schema: any,
}

const RecordsMeta: IRecordsMeta = {} as IRecordsMeta;

RecordsMeta.idBank = commonFormMeta.idBank;
RecordsMeta.nameBank = commonFormMeta.nameBank;

RecordsMeta.startDate = commonFormMeta.startDate;
RecordsMeta.endDate = commonFormMeta.endDate;

RecordsMeta.PAN = {
  name: 'PAN',
  type: 'select',
  label: 'PAN',
  options:  [
    {
      label: 'PAN A',
      value: 'a'
    },
    {
      label: 'PAN B',
      value: 'b',
    },
    {
      label: 'PAN C',
      value: 'b',
    },
  ],
  validation: yup.string().required(),
};


RecordsMeta.schema = yup.object().shape(getValidationSchema(RecordsMeta));

export default RecordsMeta;

